module.exports = __webpack_public_path__ + "img/image 2.0da5d5f9.svg";